import React from "react";
import { menuOther } from "./Datamenu_inc";
import { motion } from "framer-motion";
import { Tooltip } from "react-tooltip";
import "viewerjs/dist/viewer.css";

export const DataOther_1 = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuOther[0].name}</span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            บริการเหล่านี้มีให้แก่หน่วยงานทั้งภาครัฐและเอกชน
            เพื่อการตรวจวินิจฉัยโรคในสัตว์เลี้ยง สัตว์เศรษฐกิจ
            รวมถึงการตรวจเพื่องานวิจัยด้วย
          </span>
          <li title="">
            การตรวจวิเคราะห์เลือดเพื่อวินิจฉัยโรคต่างๆ 🩸 โลหิตวิทยา
          </li>
          <li title="">
            การตรวจวิเคราะห์สารเคมีในเลือดและของเหลวในร่างกาย 🧪 เคมีคลินิก
          </li>
          <li title="">
            การตรวจวิเคราะห์ตัวอย่างเนื้อเยื่อและเซลล์ 🔬 จุลทรรศนศาสตร์คลินิก
          </li>
          <li title="">
            การผลิตภัณฑ์เลือดและทดสอบการเข้ากันได้ของเลือด 🏥
            ธนาคารเลือดเพื่อสัตว์เลี้ยง
          </li>
          <li title="">
            การตรวจวิเคราะห์โรคจากตัวอย่างเนื้อเยื่อและเซลล์ ⚕️ พยาธิวิทยา
          </li>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>วันที่เปิดให้บริการ</span>
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 น.</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>

      {/* Tooltip */}
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="absolute top-1/2 right-0 transform -translate-x-1/2 -translate-y-1/2"
      >
        <div className=" h-full w-full">
          <div className="flex flex-col px-3 py-2 gap-y-2">
            <div
              onClick={() => window.open("tel:05394 8080")}
              className="
              bg-[#0F4D81] text-white hover:bg-blue-900 cursor-pointer 
              w-10 h-10 rounded-full flex items-center justify-center
              "
              data-tooltip-id="call-tooltip"
            >
              <i className="fa fa-phone"></i>
            </div>
            <Tooltip id="call-tooltip" place="right" content="0 5394 8080" />
            <div
              onClick={() =>
                window.open("mailto:vetlab.cmu@gmail.com", "_blank")
              }
              className="bg-red-500 text-white hover:bg-red-800 cursor-pointer
               w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="email-tooltip"
            >
              <i className="fa fa-envelope"></i>
            </div>
            <Tooltip
              id="email-tooltip"
              place="right"
              content="vetlab.cmu@gmail.com"
            />
            <div
              onClick={() => window.open("/PDF/Form-6.pdf", "_blank")}
              className="bg-green-700 text-white hover:bg-green-900 cursor-pointer
               w-10 h-10 rounded-full flex items-center justify-center"
              data-tooltip-id="download-tooltip"
            >
              <i className="fa fa-download"></i>
            </div>
            <Tooltip
              id="download-tooltip"
              place="right"
              content="ดาวน์โหลดแบบฟอร์ม"
            />
          </div>
        </div>
      </motion.div>
    </>
  );
};

export const DataOther_2 = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuOther[1].name}</span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            บริการทั้งหมดนี้ดำเนินการโดยทีมงานที่มีประสบการณ์และได้มาตรฐาน
            เพื่อให้สัตว์เลี้ยงของคุณได้รับการดูแลอย่างดีที่สุด
          </span>
          <li title="">
            หออภิบาลสัตว์ป่วย: สำหรับสัตว์ป่วยที่ต้องการการดูแลอย่างใกล้ชิด
          </li>
          <li title="">
            ห้องพักฟื้น: สำหรับสัตว์ป่วยที่กำลังฟื้นตัวหลังการรักษาหรือผ่าตัด
          </li>
          <li title="">
            ห้องเยี่ยมสัตว์ป่วยใน:
            สำหรับเจ้าของสัตว์เลี้ยงที่ต้องการเยี่ยมสัตว์ป่วย
          </li>
          <li title="">
            ห้องกักโรค: สำหรับสัตว์ป่วยที่มีโรคติดเชื้อ
            เพื่อป้องกันการแพร่กระจายของโรค
          </li>
          <li title="">
            หออภิบาลสัตว์ป่วยวิกฤต:
            สำหรับสัตว์ป่วยฉุกเฉินและวิกฤตที่ต้องการการดูแลอย่างเร่งด่วนและต่อเนื่อง
          </li>
        </div>

        <div className="flex flex-col gap-y-3 text-gray-500">
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            ติดต่อเข้าเยี่ยมสัตว์ป่วยใน และ โทรสอบถามอาการ
          </div>
          <div className="flex justify-start items-center gap-3">
            <div className="bg-[#0F4D81] text-gray-100 w-10 h-10 rounded-full flex items-center justify-center">
              <i className="fa fa-phone"></i>
            </div>
            <div>053-123-456 ต่อ 401 / หน้าเคาเตอร์ชั้น 4 </div>
          </div>
          <div className="flex justify-start items-center gap-3">
            <div className="bg-[#0F4D81] text-gray-100 w-10 h-10 rounded-full flex items-center justify-center">
              <i className="fa-solid fa-calendar-day"></i>
            </div>
            <div>
              ทุกวันและเวลาทำการ{" "}
              <span className="text-red-800">(ยกเว้นวันหยุดนักขัตฤกษ์)</span>{" "}
            </div>
          </div>
          <div className="flex justify-start items-center gap-3">
            <div className="bg-[#0F4D81] text-gray-100 w-10 h-10 rounded-full flex items-center justify-center">
              <i className="fa fa-clock"></i>
            </div>
            8:30 - 16:30 น.
          </div>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>
              วันที่และเวลาเยี่ยมสัตว์ป่วยใน{" "}
              <span className="text-red-800">(ยกเว้นวันหยุดนักขัตฤกษ์)</span>{" "}
            </span>
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>15:00 - 18:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>15:00 - 18:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>15:00 - 18:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>15:00 - 18:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>15:00 - 18:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-purple-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>เสาร์</span>
                </p>
              </div>
              <div className="bg-purple-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>14:00 - 17:00 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-red-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>อาทิยต์</span>
                </p>
              </div>
              <div className="bg-red-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>14:00 - 17:00 </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};

export const DataOther_3 = () => {
  const data = [
    {
      id: 1,
      img: "/images/animal/02.png",
      title: `ลำดับที่ 1`,
      themeColor: "bg-gradient-to-t from-red-800 to-red-500",
      status_animal: "สัตว์ป่วยฉุกเฉิน (เร่งด่วน)",
      detail: "มีภาวะคุกคามต่อชีวิตหากไม่ได้รับการรักษาทันที่",
      messageEx: "ตัวอย่าง ได้รับสารพิษ",
      messageList: [
        {
          megId: 1,
          textDetail: "หมดสติ",
          megDetail: ``,
        },
        {
          megId: 2,
          textDetail: "งูกัด",
          megDetail: ``,
        },
        {
          megId: 3,
          textDetail: "ชัก",
          megDetail: ``,
        },
        {
          megId: 4,
          textDetail: "กระเพาะอาหารบิด",
          megDetail: ``,
        },
        {
          megId: 5,
          textDetail: "ลมแดด (Heat Stroke)",
          megDetail: ``,
        },
        {
          megId: 6,
          textDetail: "กระดูกหักแบบเปิด",
          megDetail: ``,
        },
        {
          megId: 7,
          textDetail: "อาการแพ้",
          megDetail: ``,
        },
        {
          megId: 8,
          textDetail: "รถชน",
          megDetail: ``,
        },
        {
          megId: 9,
          textDetail: "หายใจลำบาก",
          megDetail: ``,
        },
        {
          megId: 10,
          textDetail: "เลือดออกปริมาณมาก",
          megDetail: ``,
        },
        {
          megId: 11,
          textDetail: "อัมพาดเฉียบพลัน",
          megDetail: ``,
        },
      ],
    },
    {
      id: 2,
      img: "/images/animal/04.png",
      title: `ลำดับที่ 2`,
      themeColor: "bg-gradient-to-t from-yellow-800 to-yellow-400",
      status_animal: "สัตว์ป่วยฉุกเฉิน",
      detail: "มีภาวะคุกคามต่อชีวิตหากไม่ได้รับการรักษา",
      messageEx: "ตัวอย่าง",
      messageList: [
        {
          megId: 1,
          textDetail: "กระดูกหักแบบแผลปิด",
          megDetail: ``,
        },
        {
          megId: 2,
          textDetail: "ท้องเสียหรืออาเจียนรุนแรง",
          megDetail: ``,
        },
        {
          megId: 3,
          textDetail: "ลำไส้อุดตัน",
          megDetail: ``,
        },
        {
          megId: 4,
          textDetail: "คลอดยาก",
          megDetail: ``,
        },
        {
          megId: 5,
          textDetail: "หอบ",
          megDetail: ``,
        },
      ],
    },
    {
      id: 3,
      img: "/images/animal/05.png",
      title: `ลำดับที่ 3`,
      themeColor: "bg-gradient-to-t from-green-800 to-green-500",
      status_animal: "สัตว์ป่วยทั่วไป",
      detail: "สัตว์ป่วยปกติ สามารถรับการรักษาทั่วไปได้",
      messageEx: "ตัวอย่าง",
      messageList: [
        {
          megId: 1,
          textDetail: "โรคผิวหนัง",
          megDetail: ``,
        },
        {
          megId: 2,
          textDetail: "ขากระเผลก",
          megDetail: ``,
        },
        {
          megId: 3,
          textDetail: "ตาเจ็บ",
          megDetail: ``,
        },
        {
          megId: 4,
          textDetail: "หูเจ็บ",
          megDetail: ``,
        },
        {
          megId: 5,
          textDetail: "แผลฝี",
          megDetail: ``,
        },
        {
          megId: 6,
          textDetail: "แผลขนาดเล็ก",
          megDetail: ``,
        },
        {
          megId: 7,
          textDetail: "โรคป่วยเรื้อรัง",
          megDetail: ``,
        },
      ],
    },
  ];

  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuOther[2].name}</span>
        </div>

        <div className="flex flex-col gap-10">
          <div className="bg-violet-200 rounded-t-2xl  p-5">
            <div className="flex flex-col gap-y-3">
              <div className="flex flex-col md:flex-row lg:flex-row justify-between text-3xl font-bold text-gray-600">
                <span>การคัดกรองสัตว์ป่วย</span>
                <div className=" flex space-x-2">
                  <span>
                    <i className="fa fa-phone"></i>
                  </span>
                  <span>00-0000-0000</span>
                </div>
              </div>
              <div className="text-xl flex space-x-3 justify-start items-center text-gray-600">
                <i className="fa-solid fa-list-ol"></i>
                <span>โดยแบ่งสีตามกลุ่มอาการ ดังต่อไปนี้</span>
              </div>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
            {data.length > 0 &&
              data.map((item) => (
                <div
                  key={item.id}
                  className={`${item.themeColor} flex flex-col h-full rounded-tl-3xl rounded-br-3xl p-5 relative`}
                >
                  <div className="absolute top-5 left-4">
                    <i className="fa fa-plus text-gray-50 text-xl"></i>
                  </div>
                  <div className="flex flex-col gap-y-7">
                    <div className="flex justify-center mt-8">
                      <div className="border border-gray-400 shadow shadow-orange-50 w-32 h-32 rounded-full overflow-hidden">
                        <img
                          src={item.img}
                          className="object-cover"
                          alt={`imganimal ${item.id}`}
                        />
                      </div>
                    </div>
                    <div className="flex flex-col gap-3 bg-gray-200/50 rounded-xl h-full md:h-[600px] lg:h-[600px]  py-4 px-4">
                      <div className="flex justify-center text-3xl text-gray-800 font-bold space-x-3">
                        <i className="fa-solid fa-arrows-spin text-red-900"></i>
                        <span>{item.title}</span>
                      </div>
                      <div className="flex items-center text-wrap text-gray-800 text-xl font-medium space-x-3">
                        <i className="fa-solid fa-square-caret-right text-teal-600"></i>
                        <span className="text-center">{item.detail}</span>
                        <i className="fa-solid fa-square-caret-left text-teal-600"></i>
                      </div>
                      <div className="flex items-center text-gray-800 font-medium space-x-2">
                        <i className="fa-solid fa-circle-exclamation text-blue-800"></i>
                        <span>{item.messageEx}</span>
                      </div>
                      {item.messageList.length > 0 &&
                        item.messageList.map((e, index) => (
                          <div key={index} className="text-gray-800 space-x-3">
                            <i className="fa-solid fa-star text-yellow-400"></i>
                            <span>{e.textDetail}</span>
                          </div>
                        ))}
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </motion.div>
    </>
  );
};

export const DataOther_4 = () => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.6 }}
        className="flex flex-col  gap-10 py-20 lg:px-0 px-10"
      >
        <div className="text-3xl lg:text-7xl font-bold text-[#0F4D81] ">
          <span className="drop-shadow-lg">{menuOther[3].name}</span>
        </div>
        <div className="text-gray-500 flex flex-col justify-start gap-y-3">
          <span className="text-[#9E76B3] text-lg">
            รายละเอียดการให้บริการตรวจวินิจฉัยและรักษาโรคอายุรกรรมในสัตว์เลี้ยง
          </span>
          <div className="flex flex-col lg:flex-row lg:gap-3">
            <span className="font-bold">ทีมสัตวแพทย์ที่มีประสบการณ์</span>
            <li>ทีมสัตวแพทย์ที่ผ่านการฝึกอบรมทางอายุรกรร</li>
            <li>มีประสบการณ์ในการรักษาโรคอายุรกรรมในสัตว์เลี้ย</li>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-3">
            <span className="font-bold">
              การให้บริการและคำปรึกษาปัญหาสุขภาพ
            </span>
            <li>ให้คำปรึกษาเกี่ยวกับปัญหาสุขภาพทั่วไป</li>
            <li>ให้คำแนะนำในการดูแลสัตว์เลี้ยงที่มีอาการป่วยเรื้อรัง</li>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-3">
            <span className="font-bold">เครื่องมือทางการแพทย์ที่ทันสมัย</span>
            <li>ใช้เครื่องมือทางการแพทย์ที่ทันสมัยและได้มาตรฐาน</li>
            <li>มีอุปกรณ์ที่สามารถตรวจวินิจฉัยโรคได้อย่างแม่นยำ</li>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-3">
            <span className="font-bold">การรักษาโรคทั่วไป</span>
            <li>ให้บริการรักษาโรคทั่วไปในสัตว์เลี้ยง</li>
            <li>ดูแลสุขภาพสัตว์เลี้ยงในทุกช่วงวัย</li>
          </div>
          <div className="flex flex-col lg:flex-row lg:gap-3">
            <span className="font-bold">
              การรักษาอาการป่วยเรื้อรังที่ซับซ้อน
            </span>
            <li>ให้บริการรักษาอาการป่วยเรื้อรังที่มีความซับซ้อน</li>
            <li>มีการติดตามและดูแลสุขภาพสัตว์เลี้ยงอย่างต่อเนื่อง</li>
          </div>
        </div>

        <div>
          <div className="text-xl mb-3 font-bold text-[#0F4D81]">
            <span>วันและเวลาให้บริการ</span>{" "}
            <span className="text-red-800">(ยกเว้นวันหยุดนักขัตฤกษ์)</span>{" "}
          </div>
          <div className="lg:flex grid grid-cols-1 justify-start items-center gap-4">
            <div className="flex flex-col gap-y-2">
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> จันทร์
                </p>
              </div>
              <div className="bg-yellow-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 20:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> อังคาร
                </p>
              </div>
              <div className="bg-pink-400 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 20:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พุธ
                </p>
              </div>
              <div className="bg-green-600 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 20:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> พฤหัสบดี
                </p>
              </div>
              <div className="bg-orange-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 20:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>ศุกร์</span>
                </p>
              </div>
              <div className="bg-cyan-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 20:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-purple-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>เสาร์</span>
                </p>
              </div>
              <div className="bg-purple-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 </span>
                </p>
              </div>
            </div>

            <div className="flex flex-col gap-y-2">
              <div className="bg-red-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-calendar"></i> <span>อาทิยต์</span>
                </p>
              </div>
              <div className="bg-red-500 p-2 rounded-lg shadow">
                <span className="font-bold"></span>
                <p className="text-sm text-gray-100">
                  <i className="fa fa-clock"></i> <span>08:30 - 16:30 </span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </motion.div>
    </>
  );
};
